module.exports = __webpack_public_path__ + "assets/img/logo-h.1272d390.png";